module.exports = __webpack_public_path__ + "img/box-plot.1dfd0d28.svg";